import { REPORT_DETAILS } from "@luckymenu/staff-core";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { ReportDetailPage } from "../features/reports/report-detail";
import { validateReportSearch } from "../features/reports/search";
import { Require } from "../features/require";

/** More > Reports > one report (P11-T06). An unknown report goes back to the list. */
export const Route = createFileRoute("/more/reports/$report")({
	validateSearch: validateReportSearch,
	beforeLoad: ({ params }) => {
		if (!(REPORT_DETAILS as readonly string[]).includes(params.report)) {
			throw redirect({ to: "/more/reports", replace: true });
		}
	},
	component: Page,
});

function Page() {
	const { report } = Route.useParams();
	const search = Route.useSearch();
	const name = REPORT_DETAILS.find((r) => r === report);
	if (!name) return null;
	return (
		<Require permission="reports.view">
			<ReportDetailPage key={name} report={name} initial={search} />
		</Require>
	);
}
